//@flow
import {
  CREATE_COACHING_SESSION_REQUESTING,
  GET_ACTIVE_COACHING_SESSION_REQUESTING,
  GET_COACHING_RESOURCES_REQUESTING,
  GET_COACHING_SESSION_REQUESTING,
  SUBMIT_RESOURCE_FEEDBACK_REQUESTING,
  UPDATE_COACHING_SESSION_REQUESTING,
  VISIT_RESOURCE_REQUESTING,
} from "./constants";

// utilisé ? c'est dans dashboard mais psa utilisé dans mobile j'ai l'impression
export const getCoachingSessionRequest = (payload: {
  coachId: string;
  userId: string;
}) => {
  return {
    type: GET_COACHING_SESSION_REQUESTING,
    payload,
  };
};

// même chose
export const updateCoachingSessionRequest = (payload: {}) => {
  return {
    type: UPDATE_COACHING_SESSION_REQUESTING,
    payload,
  };
};

// même chose
export const createCoachingSessionRequest = (payload: {}) => {
  return {
    type: CREATE_COACHING_SESSION_REQUESTING,
    payload,
  };
};

export const getActiveCoachingSessionRequest = (payload: {
  userId: string;
}) => {
  return {
    type: GET_ACTIVE_COACHING_SESSION_REQUESTING,
    payload,
  };
};

// pas besoin de payload ici
export const getCoachingResourcesRequest = () => {
  return {
    type: GET_COACHING_RESOURCES_REQUESTING,
  };
};

export const visitResourceRequest = (payload: {
  resourceId: string;
  userId: string;
  coachingSessionId?: string;
  campaignId?: string;
  userCampaignId?: string;
}) => {
  return {
    type: VISIT_RESOURCE_REQUESTING,
    payload,
  };
};

// on est sur de ca ?
export const submitResourceFeedbackRequest = (payload: {
  resourceId: string;
  userId: string;
  comment: string;
  rating: number;
  coachingSessionId?: string;
  campaignId?: string;
  userCampaignId?: string;
}) => {
  return {
    type: SUBMIT_RESOURCE_FEEDBACK_REQUESTING,
    payload,
  };
};
